<template>
  <div class="service-container"
       v-show="isShow">
    <div class="header-wrapper">
      <p>饷店客服</p>
      <img src="../../common/img/service-close.png"
           @click="dismiss" />
    </div>

    <div class="content-wrapper"
         id="content">
      <div class="reminder-wrapper">
        <img src='../../common/img/service-avatar.png' />
        <p> 饷店及合伙人问题请咨询人工客服（工作时间为：工作日9:00-18:00） </p>
      </div>
      <template v-for="msg in msgList">
        <service-cell :key="msg.payload.body.messageId"
                      :right="msg.from === akid"
                      :msg="msg" />
      </template>
    </div>
    <div class="input-wrapper">
      <Input v-model="text"
             type="textarea"
             :autosize="true"
             style="width:280px"
             placeholder="请输入您要说的话…"
             @on-enter="send" />
      <button class="input-send"
              :style=" this.text? 'color:#EC2232; border:1px solid #EC2232' : 'color:#CCCCCC; border:1px solid #CCCCCC'"
              @click="send">发送</button>
    </div>
  </div>
</template>

<script>
import IM from '@akc/im-web-sdk'
import ServiceCell from './service-cell'
// import Base64 from 'crypto-js/enc-base64'
export default {
  components: { 'service-cell': ServiceCell },
  data: function () {
    let csGroupId = process.env.NODE_ENV === 'production' ? 'cbab4af62fd8453f8c7ebb63d40714e8' : 'b525490dbf184d8384340a5125efedc1'
    return {
      akid: 'a2612d561d82476baedca5df5f942d2b',
      token: '32e97811fe754eb2be5f8fb94b9921ef',
      csGroupId: csGroupId,
      im: '',
      text: '',
      msgList: [],
      isShow: false,
      vipLevel:0,
    }
  },
  mounted() {
    // this.initService()
  },
  updated() {
    this.scrollToBottom();
  },
  destroyed() {
    this.im && this.im.logout()
  },
  methods: {
    show(token, akid, vipLevel) {
      this.token = token;
      this.akid = akid;
      this.vipLevel = Number(vipLevel);
      this.isShow = true;
      this.initIM()
    },
    dismiss() {
      this.isShow = false;
      this.im && this.im.logout()
    },
    initIM() {
      let env = process.env.NODE_ENV === 'production' ? 'PROD' : 'TEST1'
      const config = {
        akid: this.akid,
        token: this.token,
        vipLevel: this.vipLevel,
        env: env,
      }
      this.im = new IM(config)
      this.im.login()
      // 一定要login以后以下方法才能用
      // 收到消息
      this.im.onMessage = (payloadArray, isSync) => {
        if (isSync) {
          return
        }
        payloadArray.forEach(msg => {
          if (msg.targetType === 2 && msg.targetId === this.csGroupId) {
            this.msgList.push(msg)
          }
        })
        console.log('payload', JSON.stringify(this.msgList))

      }
      this.scrollToBottom();
      // 发送消息成功
      this.im.sendSuccess = (msg) => {
        console.log('msg发送消息成功', msg)
        this.msgList.push(msg)
        this.text = ''
      }
      // 发送消息失败
      this.im.sendFail = (msg) => {
        console.log('msg发送消息失败', msg)
        this.msgList.push(msg)
        this.text = ''
      }
    },
    // 发送文本消息，如需发送其他消息需要自己包装
    send() {
      if (this.text.match(/^\s*$/)) {
        this.$Message.error('不能发送空白消息');
        return
      }
      this.im.sendTextMessage(this.csGroupId, 2, { content: this.text })
    },
    scrollToBottom() {
      if (!this.isShow) {
        return
      }
      this.$nextTick(() => {
        let container = document.getElementById('content')
        container.scrollTop = container.scrollHeight;
      })
    }
  }

}
</script>
<style lang="less" >
.service-container {
  width: 360px;
  height: 540px;
  background: white;
  box-shadow: 0px 5px 30px 0px rgba(235, 235, 235, 1);
  border-radius: 2px;
  border: 1px solid rgba(242, 242, 242, 1);
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 110;
  .reminder-wrapper {
    display: flex;
    width: 100%;
    padding: 20px 20px 10px 20px;
    .ivu-icon {
      vertical-align: baseline;
    }
    img {
      width: 48px;
      height: 48px;
      border-radius: 6px;
    }
    // span {
    //   display: block;
    //   // color: #7196ce;
    //   margin-top: 5px;
    // }
    p {
      width: 260px;
      text-align: start;
      font-weight: 400;
      padding: 14px 10px;
      background: #f3f3f3;
      color: #333333;
      font-size: 14px;
      border-radius: 6px;
      margin-left: 10px;
    }
  }
  .content-wrapper {
    width: 100%;
    height: 450px;
    overflow-y: auto;
  }
  .header-wrapper {
    background: #ff4e5d;
    width: 100%;
    height: 40px;
    position: relative;

    p {
      font-size: 16px;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      line-height: 40px;
      margin: 0 auto;
      width: 64px;
    }
    img {
      width: 40px;
      height: 40px;
      padding: 10px;
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  .input-wrapper {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: auto;
    min-height: 43px;
    border-top: 1px solid #e6e6e6;
    box-sizing: border-box;
    padding: 0 16px;
    display: flex;
    align-items: center;
    z-index: 111;
    background: white;
    .input-send {
      cursor: pointer;
      width: 36px;
      height: 24px;
      border-radius: 4px;
      border: 1px solid #cccccc;
      font-size: 12px;
      color: #cccccc;
      line-height: 24px;
      text-align: center;
      margin: 0 auto;
      background: white;
    }
    .ivu-input {
      border: 0px;
      font-size: 14px;
      color: #444444;
      resize: none;
    }
    .ivu-input:focus {
      border: 0;
      box-shadow: none;
    }
  }
}
</style>
